<template lang="pug">
  .div
    .columns.has-text-left
      .column.is-12
        b.has-text-grey-darker Pais:
        | &nbsp
        b.has-text-grey {{ country.countryregion }}
    .columns.has-text-left
      .column.is-12
        b.has-text-grey-darker Confirmados:
        | &nbsp
        b.has-text-grey {{ country.confirmed | numFormat }}
    .columns.has-text-left
      .column.is-12
        b.has-text-grey-darker Muertos:
        | &nbsp
        b.has-text-danger {{ country.deaths | numFormat }}
    .columns.has-text-left
      .column.is-12
        b.has-text-grey-darker Recuperados:
        | &nbsp
        b.has-text-info {{ country.recovered | numFormat }}
</template>

<script>
export default {
  name: 'CardPais',
  props: {
    country: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
